export const DraggableItemType = {
  ANSWER: 'answer',
};
